import MapFilter from '../components/MapFilter'
import Paper from 'material-ui/Paper'
import React from 'react'
import background from '../images/tim-mossholder-269176.jpg'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  landing: {
    height: '100%',
    background: `url(${background}) no-repeat`,
    backgroundSize: 'cover',
    textAlign: 'center',
    padding: '30% 0 0',
  },
  headline: {
    color: 'white',
    fontSize: '1.3rem',
    fontWeight: '800',
  },
  caption: {
    color: 'white',
    fontSize: '1.3rem',
    fontWeight: '600',
  },
  paper: {
    flex: '2 2rem',
    padding: '1rem',
    margin: '4rem 1.5rem',
    display: 'flex',
    alignItems: 'center',
    maxHeight: '20rem',
  },
  '@media (min-width: 425px)': {
    headline: {
      fontSize: '1.785rem',
    },
    caption: {
      fontSize: '1.785rem',
    },
  },
  '@media (min-width: 600px)': {
    headline: {
      fontSize: '2.5rem',
    },
    caption: {
      fontSize: '2.5rem',
    },
    paper: {
      margin: '4rem 6rem',
    },
  },
  '@media (min-width: 840px)': {
    landing: {
      padding: '15% 0 0',
    },
    headline: {
      fontSize: '3.5rem',
    },
    caption: {
      fontSize: '3.525rem',
    },
    paper: {
      margin: '4rem 7rem',
    },
  },
  '@media (min-width: 1185px)': {
    landing: {
      padding: '10% 0 0',
    },
    headline: {
      fontSize: '4.957rem',
    },
    caption: {
      fontSize: '4.957rem',
    },
    paper: {
      margin: '4rem 8rem',
    },
  },
  '@media (min-width: 1667px)': {
    landing: {
      padding: '0.01% 0 0',
    },
    headline: {
      fontSize: '6.95rem',
    },
    caption: {
      fontSize: '6.95rem',
    },
    paper: {
      margin: '4rem 20rem',
    },
  },
  '@media (min-width: 2337px)': {
    headline: {
      fontSize: '9.776rem',
    },
    caption: {
      fontSize: '9.776rem',
    },
    paper: {
      margin: '4rem 33rem',
    },
  },
  '@media (min-width: 3287px)': {
    headline: {
      fontSize: '13.454rem',
    },
    caption: {
      fontSize: '13.454rem',
    },
    paper: {
      margin: '4rem 45rem',
    },
  },
})


const Landing = ({
  classes,
  distance,
  mapCenter,
  zip,
  history,
  updateUrlParams,
}) => (
  <div className={classes.landing}>
    <p className={classes.headline}>DISCOVERING LOCAL ON A NATIONAL SCALE!</p>
    <Paper className={classes.paper}>
      <MapFilter
        commodities={[]}
        distance={distance}
        distributors={[]}
        filterClass={classes.filter}
        filterComms={[]}
        filterDists={[]}
        history={history}
        mapCenter={mapCenter}
        updateUrlParams={updateUrlParams}
        zip={zip}
      />
    </Paper>
    <p className={classes.caption}>Find a local farm near you</p>
  </div>
)
export default withStyles(styles)(Landing)



// WEBPACK FOOTER //
// ./src/views/Landing.js